import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { SkillDescriptionFieldProps } from '../../types/profileForm.types';

const SkillDescriptionField: React.FC<SkillDescriptionFieldProps> = ({
  label,
  value,
  error,
  onChange,
  onBlur,
  maxLength = 500,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = event.target.value;
    
    // Enforce character limit
    if (inputValue.length <= maxLength) {
      onChange(inputValue);
    }
  };

  const handleBlur = () => {
    onBlur();
  };

  const remainingChars = maxLength - value.length;
  const isNearLimit = remainingChars <= 50;

  return (
    <Box sx={{ mb: 1, display: 'flex', alignItems: 'flex-start' }}>
      <Typography
        variant="subtitle1"
        sx={{
          minWidth: { xs: '120px', sm: '200px' },
          flexShrink: 0,
          fontSize: '14px',
          fontWeight: 600,
          color: '#212529',
          pt: 1,
        }}
      >
        {label}
      </Typography>

      <Box sx={{ flex: 1 }}>
        <TextField
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Describe your experience with this skill..."
          multiline
          rows={3}
          error={!!error}
          helperText={
            error || (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{error}</span>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: isNearLimit ? '#dc3545' : '#6c757d',
                    fontSize: '11px'
                  }}
                >
                  {remainingChars} characters remaining
                </Typography>
              </Box>
            )
          }
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              fontSize: '16px',
              backgroundColor: '#fff',
              '& fieldset': {
                borderColor: error ? '#dc3545' : '#dee2e6',
                borderWidth: '1px',
              },
              '&:hover fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
              },
              '&.Mui-focused fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
                borderWidth: '2px',
              },
              '& textarea': {
                padding: '12px 16px',
                fontSize: '16px',
              },
            },
            '& .MuiFormHelperText-root': {
              fontSize: '12px',
              color: error ? '#dc3545' : '#6c757d',
              marginLeft: 0,
              marginTop: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default SkillDescriptionField;